function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { compare } from 'compare-versions';
import get from 'lodash/get';
import has from 'lodash/has';
import { AppContext, ProfileContext } from 'context';
import * as selectors from '../../selectors';
import Initializing from './Initializing';
import InstallDownloader from './InstallDownloader';
import InstallingDownloader from './InstallingDownloader';
import InstalledDownloader from './InstalledDownloader';
import DownloaderOutdated from './DownloaderOutdated';
import UpdateError from './UpdateError';
import NoConnection from './NoConnection';
const components = {
    Initializing,
    InstallDownloader,
    InstallingDownloader,
    InstalledDownloader,
    DownloaderOutdated,
    UpdateError,
    NoConnection
};
const getIsDownloaderOutdated = (downloader, downloaderConfig)=>{
    const clientVersion = get(downloader, 'mdaVersion');
    if (!clientVersion) {
        return false;
    }
    const minVersion = get(downloaderConfig, 'minVersion');
    return compare(clientVersion, minVersion, '<');
};
const MdaInit = (_param)=>{
    var { onSetComponent, onSetChannel } = _param, props = _object_without_properties(_param, [
        "onSetComponent",
        "onSetChannel"
    ]);
    const { downloader: downloaderConfig } = useContext(AppContext);
    const profileContext = useContext(ProfileContext);
    const downloader = useSelector(selectors.downloader);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const [componentName, setComponentName] = useState('Initializing');
    const Component = get(components, componentName, null);
    const onSetComponentName = (newComponentName)=>{
        if (!has(components, newComponentName)) {
            onSetComponent(newComponentName);
            return;
        }
        setComponentName(newComponentName);
    };
    const onInitialized = ()=>{
        const isDownloaderOutdated = getIsDownloaderOutdated(downloader, downloaderConfig);
        if (isDownloaderOutdated) {
            onSetComponentName('DownloaderOutdated');
            return;
        }
        const lastConnectionType = get(phiSet, 'summaryData.lastConnectionType');
        onSetChannel(lastConnectionType);
        onSetComponent('Connect');
    };
    return /*#__PURE__*/ _jsx(Component, _object_spread({
        onInitialized: onInitialized,
        onSetComponent: onSetComponentName
    }, props));
};
export default MdaInit;
